import { render, staticRenderFns } from "./SelectProductInStock.vue?vue&type=template&id=b4014fea&"
import script from "./SelectProductInStock.vue?vue&type=script&lang=ts&"
export * from "./SelectProductInStock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4014fea')) {
      api.createRecord('b4014fea', component.options)
    } else {
      api.reload('b4014fea', component.options)
    }
    module.hot.accept("./SelectProductInStock.vue?vue&type=template&id=b4014fea&", function () {
      api.rerender('b4014fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SalesOrder/SelectProductInStock.vue"
export default component.exports